import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { Order } from "../../types/api/Order";

export default (orgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<Order[]>(
    `buyer_orders_${orgId}`,
    async () => {
      return await Get<Order[]>(
        `/api/order/organization/${orgId}/purchasing`,
        await getAccessTokenSilently()
      );
    },
    { cacheTime: 0, enabled: !!orgId }
  );
};
